import { ApiService } from "./ApiService"

export class CentralOdcImageService {

    static uri = '/central-odc-image';

    static create({ data, id }) {
        return ApiService.post(`${this.uri}/create/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    static delete({ id }) {
        return ApiService.post(`${this.uri}/delete/${id}`, {}, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
}